var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 789 362",
    style: {
      enableBackground: "new 0 0 789 362"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,110.2H20.2v38.3h52.9v14.7H19.5c-3.9,0-7.2-1.3-9.9-4c-2.7-2.7-4-6-4-9.9v-39.8c0-3.9,1.3-7.2,4-9.9 c2.7-2.7,6-4,9.9-4h53.6V110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,95.6h39.8c3.8,0,7.1,1.4,9.8,4.1c2.7,2.7,4.1,6,4.1,9.8v39.8c0,3.8-1.4,7.1-4.1,9.8 c-2.7,2.7-6,4.1-9.8,4.1H96.5c-3.9,0-7.2-1.3-9.9-4c-2.7-2.7-4-6-4-9.9v-39.8c0-3.9,1.3-7.2,4-9.9C89.4,96.9,92.7,95.6,96.5,95.6z  M97.2,110.2v38.3h38.3v-38.3H97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.5,140.7V95.6h14.8v67.7h-15l-38.1-45.3v45.3h-14.6V95.6h15L213.5,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306,109.5v6.3h-14.8v-5.5h-38.3v11.8h39.2c3.8,0,7.1,1.4,9.8,4.1c2.7,2.7,4.1,6,4.1,9.8v13.3 c0,3.8-1.4,7.1-4.1,9.8c-2.7,2.7-6,4.1-9.8,4.1h-39.8c-3.8,0-7.1-1.3-9.8-4c-2.7-2.7-4.1-6-4.1-9.9V143h14.6v5.5h38.3v-11.8h-39 c-3.8,0-7.1-1.3-9.8-4c-2.7-2.7-4.1-6-4.1-9.9v-13.3c0-3.9,1.4-7.2,4.1-9.9c2.7-2.7,6-4,9.8-4h39.8c3.8,0,7.1,1.4,9.8,4.1 C304.6,102.4,306,105.7,306,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.4,95.6v53h38.3v-53h14.8v53.7c0,3.8-1.4,7.1-4.1,9.8c-2.7,2.7-6,4.1-9.8,4.1h-39.8c-3.9,0-7.2-1.3-9.9-4 c-2.7-2.7-4-6-4-9.9V95.6H330.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.9,163.2V95.5h14.6v53.1h53.1v14.7H393.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.6,95.6h67.7v14.7h-26.5v53h-14.7v-53h-26.5V95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.1,95.6h39.8c3.8,0,7.1,1.4,9.8,4.1c2.7,2.7,4.1,6,4.1,9.8v39.8c0,3.8-1.4,7.1-4.1,9.8 c-2.7,2.7-6,4.1-9.8,4.1h-39.8c-3.9,0-7.2-1.3-9.9-4c-2.7-2.7-4-6-4-9.9v-39.8c0-3.9,1.3-7.2,4-9.9 C544.9,96.9,548.2,95.6,552.1,95.6z M552.7,110.2v38.3h38.3v-38.3H552.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.7,109.6v17.5c0,3.8-1.4,7.1-4.1,9.8c-2.8,2.7-6,4.1-9.9,4.1H669l14.7,17.3v5h-15L650,141l-19.4,0.1 c0.2,0,0.3,0.2,0.3,0.6c-0.1,0-0.2,0-0.3-0.1v21.7H616V95.7h53.7c3.8,0,7.1,1.4,9.9,4.1C682.3,102.5,683.7,105.8,683.7,109.6z  M630.6,110.2v16.1h38.3v-16.1H630.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M693.8,163.2V95.6h14.7v67.7H693.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M728.4,95.6h39.7c3.9,0,7.2,1.4,9.9,4.1c2.7,2.7,4.1,6,4.1,9.8v53.7h-14.8v-21.8h-38.3v21.8h-14.6v-53.7 c0-3.9,1.3-7.2,4-9.9C721.3,96.9,724.5,95.6,728.4,95.6z M729.1,126.8h38.3v-16.5h-38.3V126.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,196.3h57.1c4.1,0,7.6,1.4,10.5,4.3c2.9,2.9,4.3,6.4,4.3,10.4v42.4c0,4.1-1.4,7.5-4.3,10.4 c-2.9,2.9-6.4,4.3-10.5,4.3H6.1V196.3z M21.6,211.9v40.8h40.8v-40.8H21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,196.3v15.6h-50.8v12.6H146v15.6h-40.9v12.6h50.8v15.6H89.5v-72H155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.3,244.3v-48H270v72h-16l-40.5-48.2v48.2H198v-72h16L254.3,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.8,196.3v15.6H297v12.6h40.9v15.6H297v12.6h50.8v15.6h-66.5v-72H347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.7,211.1v6.8H414v-6h-40.8v40.8H414v-10.8h-15.6v-15.6h31.3v27.2c0,4.1-1.4,7.5-4.3,10.4 c-2.9,2.9-6.4,4.3-10.5,4.3h-42.3c-4.1,0-7.6-1.4-10.5-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-42.4c0-4.1,1.4-7.6,4.3-10.5 c2.9-2.9,6.4-4.3,10.5-4.3h42.3c4.1,0,7.6,1.4,10.5,4.3C428.2,203.5,429.7,207,429.7,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.2,196.3h42.4c4.1,0,7.5,1.4,10.4,4.3c2.9,2.9,4.3,6.4,4.3,10.4v42.4c0,4.1-1.4,7.5-4.3,10.4 c-2.9,2.9-6.4,4.3-10.4,4.3h-42.4c-4.1,0-7.6-1.4-10.5-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-42.4c0-4.1,1.4-7.6,4.3-10.5 C447.6,197.7,451.1,196.3,455.2,196.3z M455.9,211.9v40.8h40.8v-40.8H455.9z M469,191.3l5.1-20.3h15.7l-5.1,20.3H469z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.2,211.9h-56.3v40.8h56.3v15.6h-57c-4.1,0-7.6-1.4-10.5-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-42.4 c0-4.1,1.4-7.6,4.3-10.5c2.9-2.9,6.4-4.3,10.5-4.3h57V211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.6,268.2v-72h15.6v72H605.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.1,196.3h42.4c4.1,0,7.5,1.4,10.4,4.3c2.9,2.9,4.3,6.4,4.3,10.4v42.4c0,4.1-1.4,7.5-4.3,10.4 c-2.9,2.9-6.4,4.3-10.4,4.3h-42.4c-4.1,0-7.6-1.4-10.5-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-42.4c0-4.1,1.4-7.6,4.3-10.5 C634.5,197.7,638,196.3,642.1,196.3z M642.8,211.9v40.8h40.8v-40.8H642.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M781.7,211.1v6.7H766v-5.9h-40.8v12.6h41.7c4.1,0,7.5,1.4,10.4,4.3c2.9,2.9,4.3,6.4,4.3,10.4v14.2 c0,4.1-1.4,7.5-4.3,10.4c-2.9,2.9-6.4,4.3-10.4,4.3h-42.4c-4.1,0-7.5-1.4-10.4-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-6.7h15.5v5.9H766 v-12.6h-41.5c-4.1,0-7.5-1.4-10.4-4.3c-2.9-2.9-4.3-6.4-4.3-10.5v-14.2c0-4.1,1.4-7.6,4.3-10.5c2.9-2.9,6.4-4.3,10.4-4.3h42.4 c4.1,0,7.5,1.4,10.4,4.3C780.3,203.5,781.7,207,781.7,211.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultoria);
export default __webpack_public_path__ + "static/media/Consultoria.62683c6f66b79313a76fa840531d74fc.svg";
export { ForwardRef as ReactComponent };